module.exports = __webpack_public_path__ + "static/media/human-advantage-header-logo.dfdb6aec.svg";